export default __webpack_public_path__ + "static/media/yarden_mark_bg_fitted.457b6e2d.svg";